"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.list.title': '入职会话',
    'onboarding.list.empty': '未找到入职会话',
    'onboarding.list.description': '管理团队成员的入职流程。',
    'onboarding.list.records': '入职记录',
};
